import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { HousekeeperSetting } from '../../models';

export const featureAdapter = createEntityAdapter<HousekeeperSetting>({
  selectId: (model) => model.id,
});

export interface State extends EntityState<HousekeeperSetting> {
  isLoading: boolean;
  error: any;
}

export const initialState: State = featureAdapter.getInitialState({
  isLoading: false,
  error: null,
});
